/**
 * Small property-type -> UI-affordance mappings shared by every page that renders
 * `PropertyConfigFields` for a property (the per-template Property Editor and the
 * System Properties admin page), so the two stay in lockstep.
 */

/** Which service `ResponseType` a property type's `source: service` (or ServiceLookup) can consume. */
export function serviceResponseTypeFor(propertyType: string): string {
  switch (propertyType) {
    case 'Image':
      return 'Image';
    case 'Table':
      return 'Table';
    case 'List':
      return 'List';
    case 'DocumentDictionary':
      return 'Document';
    default:
      return 'Text';
  }
}

/** Which reference-data use is relevant to a property's type, for the Default Value picker's "Reference data" tab. */
export function referenceUseFor(propertyType: string): string {
  switch (propertyType) {
    case 'Image':
      return 'image';
    case 'Table':
      return 'table';
    case 'DocumentDictionary':
      return 'document';
    default:
      return 'text';
  }
}
